import React, { Component } from 'react'
import { connect } from 'react-redux'
import { change, destroy } from 'redux-form'
import moment from 'moment'
import { parseQueryForDisplay, stringifyQuery } from '../../helpers/queryHelper'
import { History } from 'history'
import ProductFilterForm from '../products/productFilterForm'
import {
  hasNarrowingFilters,
  PRODUCTS_DEFAULT_WINDOW_DAYS,
} from './productHelpers'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  change: Callback
  destroy: Callback
  history: History
  location: Location
}

export class ProductFilter extends Component<Props> {
  componentDidMount() {
    const {
      history,
      location: { search },
    } = this.props
    if (typeof search === 'string') {
      const parsed = parseQueryForDisplay(search)
      const defaultStatuses = [
        'empty',
        'quoted',
        'selected',
        'booked',
        'payment_succeeded',
        'payment_failed',
        'agreement_signed',
        'payment_agreement_signed',
        'product_agreement_signed',
        'remitted',
        'active',
        'late',
        'pending_late',
        'pending_cancel',
        'cancelled',
        'back_out',
        'product_remitted_error',
        'payment_remitted_error',
        'product_and_payment_remitted_error'
      ]
      if (parsed.productPackage == null) {
        const newQuery = Object.assign({}, parsed, {
          productPackage: defaultStatuses,
        })
        const nav =
          typeof history.replace === 'function' ? history.replace : history.push
        nav({
          pathname: '/products/filters',
          search: stringifyQuery(newQuery),
        })
      }
    }
  }

  onSubmit = (values) => {
    const { history } = this.props
    const withDefaults = Object.assign({}, values, {
      offset: 0,
      limit: 25,
    })
    history.push({
      pathname: '/products',
      search: stringifyQuery(withDefaults),
    })
  }

  cancel = () => {
    const {
      history,
      location: { search },
    } = this.props
    history.push({
      pathname: '/products',
      search,
    })
  }

  destroy = () => {
    const {
      change,
      destroy,
      history,
      location: { search },
    } = this.props
    destroy('productFilterForm')
    const valueArray = Object.keys(parseQueryForDisplay(search))
    valueArray.forEach((value) => {
      change('productFilterForm', value, null)
    })
    history.push({
      pathname: '/products',
    })
  }

  initialValues = () => {
    const { location } = this.props
    const parsed = parseQueryForDisplay(location.search)
    const defaultStatuses = [
      'empty',
      'quoted',
      'selected',
      'booked',
      'payment_succeeded',
      'payment_failed',
      'agreement_signed',
      'payment_agreement_signed',
      'product_agreement_signed',
      'remitted',
      'active',
      'late',
      'pending_late',
      'pending_cancel',
      'cancelled',
      'back_out',
      'product_remitted_error',
      'payment_remitted_error',
      'product_and_payment_remitted_error',
    ]
    const result: any = { productPackage: defaultStatuses, ...parsed }

    if (!hasNarrowingFilters(parsed) && !parsed.updatedAtAfter) {
      result.updatedAtAfter = moment()
        .subtract(PRODUCTS_DEFAULT_WINDOW_DAYS, 'days')
        .startOf('day')
        .format('MM/DD/YYYYTHH:mm:ss Z')
    }

    return result
  }

  render() {
    return (
      <div className="index-filter">
        <h1 className="index-filter__header">Filters</h1>
        <ProductFilterForm
          onSubmit={this.onSubmit}
          initialValues={this.initialValues()}
          cancel={this.cancel}
          clear={this.destroy}
        />
      </div>
    )
  }
}

export default connect(null, {
  change,
  destroy,
})(ProductFilter)
